var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import ToggleStateless from './toggle-stateless';
var Toggle = (function (_super) {
    __extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isChecked: _this.props.isChecked ? _this.props.isChecked : false,
        };
        return _this;
    }
    Toggle.prototype.handleChange = function (e) {
        this.setState({ isChecked: !this.state.isChecked });
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };
    Toggle.prototype.render = function () {
        var _this = this;
        return (React.createElement(ToggleStateless, { name: this.props.name, onChange: function (e) { return _this.handleChange(e); }, isChecked: this.state.isChecked, isDisabled: this.props.isDisabled, value: this.props.value }));
    };
    return Toggle;
}(React.Component));
export default Toggle;
//# sourceMappingURL=toggle.js.map